import {
    useBreakpoint,
    isDesktop
} from 'tradera-components/breakpoint/breakpoint';

const useIsDesktop = () => isDesktop(useBreakpoint());

export default useIsDesktop;
